
import React from 'react'
import T from 'prop-types'

const ACTIVE_CLASS = `is_active`

const MiniCircleLoader = props => {
  return (
    <svg className={`mini_circle_loader ${props.active ? ACTIVE_CLASS : ''}`} data-tooltip={`Saving...`}>
      <circle cx="50%" cy="50%" r="4" />
    </svg>
  )
}

MiniCircleLoader.displayName = "MiniCircleLoader"
MiniCircleLoader.propTypes = {
  active: T.bool
}

export default MiniCircleLoader
